import { buildScopedI18n } from '../../utils/buildScopedI18n';
import idMonitoringEsCL from './locales/es-CL.json';
import idMonitoringEnUS from './locales/en-US.json';
import idMonitoringPtBR from './locales/pt-BR.json';

export const idMonitoringI18n = buildScopedI18n({
  esCL: idMonitoringEsCL,
  enUS: idMonitoringEnUS,
  ptBR: idMonitoringPtBR,
});
